import { keyframes as emotionkeyframes } from "@emotion/react"
import { keyframes } from "styled-components"
// Different keyframe animations
// export const fade = keyframes`
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// `

export const fadeInUpKeyframes = emotionkeyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 10%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

export const marqueeKeyframe = keyframes`
   0% {
     transform: translateX(0%);
   }
   100% {
     transform: translateX(-60%);
   }
`
